export default __webpack_public_path__ + "static/media/room-3-theme.8351061c.jpg";